module.exports = __webpack_public_path__ + "img/TmenzhenA.57f42371.svg";